import { sendContactRequest } from './contactService.server';

const contactService = {
  sendContactRequest
};

export { contactService as contact };
